mutation DetachEventYouTubeForeignSource($eventId: ID!, $channelId: String!) {
  result: StreamToolsDetachEventYouTubeForeignSource(eventId: $eventId, channelId: $channelId) {
    eventId
    attached
    refusalCode
    message
    source {
      channelId
      videoId
      attestedAt
      channelTitle
      channelProfileImageUrl
    }
    session {
      sessionId
      eventId
      scope
      status
      startedAt
      stoppedAt
      stopReason
      channelId
      channelTitle
      videoId
      channelProfileImageUrl
      foreignEvent
    }
  }
}
